// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LicensePopup_content_container__UgpYT {
  padding: 5px;
}

.LicensePopup_claim_hr__By5Ro {
  height: 1px;
  border: none;
  background-color: var(--color-theme-silver);
  margin: 10px 0px;
  width: 100%;
}

.LicensePopup_btn_additional_fees__1fqQG {
  flex: 2 1;
  font-weight: 600 !important;
  color: var(--color-font-10) !important;
  height: 40px;
  max-width: 300px !important;
  line-height: 0px !important;
}

.LicensePopup_findings_container__QJnQ3 {
  display: block;
}

.LicensePopup_empty_state__f-Av5 {
  padding: 16px;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  font-size: 14px;
}

.LicensePopup_finding_container__Zc3WY {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.LicensePopup_finging_image_container__TldM9 {
  width: 120px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.LicensePopup_finging_image_container__TldM9 svg {
  color: var(--color-theme-10);
  width: 120px;
  height: 60px;
}

.LicensePopup_license_link__0I9z- {
  text-decoration: none;
  color: var(--color-theme-10);
}

.LicensePopup_finging_image__HH-W\\+ {
  height: 85px;
  width: 100%;
  border-radius: 2px;
  object-fit: cover;
}

.LicensePopup_finging_details_container__NEQnA {
  width: 350px;
  padding: 0px 20px;
}

.LicensePopup_finding_date__YqNFY {
  font-size: 12px;
  padding: 5px 0px;
}

.LicensePopup_finding_note__ae8nu {
  font-size: 14px;
  padding-top: 15px;
}

.LicensePopup_finding_link__8SIcY {
  text-decoration: none;
  color: var(--color-font-10);
  font-size: 18px;
  font-weight: bold;
}

.LicensePopup_finging_validity_container__UsPzO {
  width: 100px;
  padding-left: 20px;
  border-radius: 5px;
}

.LicensePopup_add_fee_container__QPBzw {
  text-align: right;
}

.LicensePopup_additional_fees_container__-xOCV {
  display: block;
}

.LicensePopup_additional_fee_container__-ZiG3 {
  display: flex;
}

.LicensePopup_other_fees_container__cj2lJ {
  display: block;
}

.LicensePopup_vat_container__niuB\\+ {
  display: flex;
  justify-content: space-between;
}

::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

.LicensePopup_first_input__O6v\\+g {
  margin-right: 20px !important;
}

.LicensePopup_settelment_container__dEjcX {
  display: flex;
  justify-content: space-between;
}

.LicensePopup_taxable_switch_container__s51yV {
  display: block;
  width: 190px;
  padding-top: 5px;
}

.LicensePopup_taxable_label__5\\+tE6 {
  font-size: 10px;
  text-align: center;
}

.LicensePopup_taxable_switch__LfC5N {
  margin-left: 10px !important;
  margin-top: 0px !important;
}

.LicensePopup_btn_delete_container__RVFHU {
  width: 90px;
  padding-top: 35px;
  text-align: left;
  color: var(--color-theme-red);
}

.LicensePopup_summary_container__FUnlI {
  display: flex;
  justify-content: space-between;
  background-color: var(--color-theme-darkgray);
  padding: 5px 15px;
}

.LicensePopup_license_container__Puzfv {
  margin-right: 15px;
}

.LicensePopup_gross_container__X6BSY {
  margin-right: 15px;
}

.LicensePopup_discount_container__a9WQD {
  margin-right: 15px;
}

.LicensePopup_sumary_label__e\\+mYb {
  font-size: 12px;
}

.LicensePopup_sumary_value__uq\\+U4 {
  font-size: 18px;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/LicensePopup/LicensePopup.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,2BAA2B;EAC3B,sCAAsC;EACtC,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".content_container {\n  padding: 5px;\n}\n\n.claim_hr {\n  height: 1px;\n  border: none;\n  background-color: var(--color-theme-silver);\n  margin: 10px 0px;\n  width: 100%;\n}\n\n.btn_additional_fees {\n  flex: 2;\n  font-weight: 600 !important;\n  color: var(--color-font-10) !important;\n  height: 40px;\n  max-width: 300px !important;\n  line-height: 0px !important;\n}\n\n.findings_container {\n  display: block;\n}\n\n.empty_state {\n  padding: 16px;\n  color: rgba(0, 0, 0, 0.6);\n  text-align: center;\n  font-size: 14px;\n}\n\n.finding_container {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 10px;\n}\n\n.finging_image_container {\n  width: 120px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.finging_image_container svg {\n  color: var(--color-theme-10);\n  width: 120px;\n  height: 60px;\n}\n\n.license_link {\n  text-decoration: none;\n  color: var(--color-theme-10);\n}\n\n.finging_image {\n  height: 85px;\n  width: 100%;\n  border-radius: 2px;\n  object-fit: cover;\n}\n\n.finging_details_container {\n  width: 350px;\n  padding: 0px 20px;\n}\n\n.finding_date {\n  font-size: 12px;\n  padding: 5px 0px;\n}\n\n.finding_note {\n  font-size: 14px;\n  padding-top: 15px;\n}\n\n.finding_link {\n  text-decoration: none;\n  color: var(--color-font-10);\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.finging_validity_container {\n  width: 100px;\n  padding-left: 20px;\n  border-radius: 5px;\n}\n\n.add_fee_container {\n  text-align: right;\n}\n\n.additional_fees_container {\n  display: block;\n}\n\n.additional_fee_container {\n  display: flex;\n}\n\n.other_fees_container {\n  display: block;\n}\n\n.vat_container {\n  display: flex;\n  justify-content: space-between;\n}\n\n::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n}\n\n.first_input {\n  margin-right: 20px !important;\n}\n\n.settelment_container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.taxable_switch_container {\n  display: block;\n  width: 190px;\n  padding-top: 5px;\n}\n\n.taxable_label {\n  font-size: 10px;\n  text-align: center;\n}\n\n.taxable_switch {\n  margin-left: 10px !important;\n  margin-top: 0px !important;\n}\n\n.btn_delete_container {\n  width: 90px;\n  padding-top: 35px;\n  text-align: left;\n  color: var(--color-theme-red);\n}\n\n.summary_container {\n  display: flex;\n  justify-content: space-between;\n  background-color: var(--color-theme-darkgray);\n  padding: 5px 15px;\n}\n\n.license_container {\n  margin-right: 15px;\n}\n\n.gross_container {\n  margin-right: 15px;\n}\n\n.discount_container {\n  margin-right: 15px;\n}\n\n.sumary_label {\n  font-size: 12px;\n}\n\n.sumary_value {\n  font-size: 18px;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content_container": `LicensePopup_content_container__UgpYT`,
	"claim_hr": `LicensePopup_claim_hr__By5Ro`,
	"btn_additional_fees": `LicensePopup_btn_additional_fees__1fqQG`,
	"findings_container": `LicensePopup_findings_container__QJnQ3`,
	"empty_state": `LicensePopup_empty_state__f-Av5`,
	"finding_container": `LicensePopup_finding_container__Zc3WY`,
	"finging_image_container": `LicensePopup_finging_image_container__TldM9`,
	"license_link": `LicensePopup_license_link__0I9z-`,
	"finging_image": `LicensePopup_finging_image__HH-W+`,
	"finging_details_container": `LicensePopup_finging_details_container__NEQnA`,
	"finding_date": `LicensePopup_finding_date__YqNFY`,
	"finding_note": `LicensePopup_finding_note__ae8nu`,
	"finding_link": `LicensePopup_finding_link__8SIcY`,
	"finging_validity_container": `LicensePopup_finging_validity_container__UsPzO`,
	"add_fee_container": `LicensePopup_add_fee_container__QPBzw`,
	"additional_fees_container": `LicensePopup_additional_fees_container__-xOCV`,
	"additional_fee_container": `LicensePopup_additional_fee_container__-ZiG3`,
	"other_fees_container": `LicensePopup_other_fees_container__cj2lJ`,
	"vat_container": `LicensePopup_vat_container__niuB+`,
	"first_input": `LicensePopup_first_input__O6v+g`,
	"settelment_container": `LicensePopup_settelment_container__dEjcX`,
	"taxable_switch_container": `LicensePopup_taxable_switch_container__s51yV`,
	"taxable_label": `LicensePopup_taxable_label__5+tE6`,
	"taxable_switch": `LicensePopup_taxable_switch__LfC5N`,
	"btn_delete_container": `LicensePopup_btn_delete_container__RVFHU`,
	"summary_container": `LicensePopup_summary_container__FUnlI`,
	"license_container": `LicensePopup_license_container__Puzfv`,
	"gross_container": `LicensePopup_gross_container__X6BSY`,
	"discount_container": `LicensePopup_discount_container__a9WQD`,
	"sumary_label": `LicensePopup_sumary_label__e+mYb`,
	"sumary_value": `LicensePopup_sumary_value__uq+U4`
};
export default ___CSS_LOADER_EXPORT___;
